// Visual styles for decorative paths drawn by the DM.
// Purely aesthetic — no gameplay effect on movement, vision, fog, or pathfinding.
// Each style maps to Konva Line attributes used in PathLayer.

export const PATH_STYLES = {
  dirt: {
    stroke: '#8a6a3a',
    strokeWidth: 14,
    dash: [12, 4],
    opacity: 0.85,
    shadow: 'rgba(0,0,0,0.45)',
    shadowBlur: 0,
  },
  stone: {
    stroke: '#8a8a8e',
    strokeWidth: 18,
    opacity: 0.78,
    shadow: 'rgba(0,0,0,0.5)',
    shadowBlur: 0,
  },
  grass: {
    stroke: '#4a7a30',
    strokeWidth: 14,
    dash: [4, 6],
    opacity: 0.7,
    shadow: 'rgba(0,0,0,0.3)',
    shadowBlur: 0,
  },
  snow: {
    stroke: '#dde8f4',
    strokeWidth: 12,
    dash: [3, 8],
    opacity: 0.85,
    shadow: 'rgba(80,110,140,0.55)',
    shadowBlur: 2,
  },
  blood: {
    stroke: '#8a1a1a',
    strokeWidth: 10,
    opacity: 0.78,
    shadow: 'rgba(40,0,0,0.7)',
    shadowBlur: 4,
  },
  magical: {
    stroke: '#a070ff',
    strokeWidth: 6,
    opacity: 0.95,
    shadow: 'rgba(160,112,255,0.9)',
    shadowBlur: 14,
  },
};

export const DEFAULT_PATH_STYLE = 'dirt';
